import { SalesAccountBase } from "../salesAccountsTypes"

export const prepareInitialValues = (result?: SalesAccountBase) => {
    return {
        name: result?.name ?? "",
        number: result?.number ?? "",
        isActive: result?.isActive ?? true,
    }
}
